import React, { useState, useEffect } from "react";
import { Typography, useMediaQuery } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Icons } from "../config/MuiIcons.config";
import Header from "../components/Header/Header.component";
import Sidebar from "../components/SideBar/Sidebar.commponent";
// Sidebar width
import { SidebarWidth } from "../config/SidebarConfig";
import { useLocation, Link } from "react-router-dom";

const drawerWidth = SidebarWidth;

// MUI Drawer Header component css and style
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

// Main component css and style
const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(2),
    height: '100vh',
    marginLeft: `-${drawerWidth}px`,
    width: '100%',
    ...(open && {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: 0,
    }),
  })
);

const Layout = ({ children }) => {
  const theme = useTheme();
  let isTabletMid = useMediaQuery("(max-width: 768px)");
  const { pathname } = useLocation();
  const [open, setOpen] = useState(true);

  useEffect(() => {
    if (isTabletMid) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [isTabletMid]);

  useEffect(() => {
    isTabletMid && setOpen(false);
  }, [pathname, isTabletMid]);

  const handleSideBarToggle = () => {
    setOpen((e) => !e);
  };

  const SideBarVariantProps = isTabletMid && open ? {} : { variant: "persistent" }

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Header HandleSideBarOpen={handleSideBarToggle} IsSideBarOpen={open} />
      <Drawer
        open={open}
        onClose={handleSideBarToggle}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
        {...SideBarVariantProps}
      >
        <DrawerHeader />

        {/* This is the sidebar */}
        <Sidebar IsSidebarOpen={open} />

        {/* Drower Header */}
        <DrawerHeader sx={{ mt: "auto", borderTop: "1px solid #DCDCDC" }}>
          <Typography
            variant="subtitle2"
            className="inter-regular-400 text-dark"
            align="center"
            style={{ fontSize: "12px" }}
          >
            {"© "}
            {new Date().getFullYear()}{" "}
            <Link
              to={"https://zingworks.in"}
              target="_blank"
              className="text-dark"
            >
              Zingworks
            </Link>{" "}
            All rights reserved.
          </Typography>
          {/* <IconButton onClick={handleSideBarToggle}>
            {theme.direction === "ltr" ? (
              <Icons.KeyboardTabIcon sx={{ transform: "rotate(180deg)" }} />
            ) : (
              <Icons.KeyboardTabIcon />
            )}
          </IconButton> */}
        </DrawerHeader>
      </Drawer>
      <Main open={open}>
        <DrawerHeader />
        {children}
      </Main>
    </Box>
  );
};

export default Layout;
